<template lang="pug">
  div
    v-textarea(
      v-show="false"
      v-model="value.string_answer"
      rounded filled
      disabled
    )
    v-alert(color="grey lighten-4")
      strong.mr-2 Ответ:
      span {{ value.string_answer }}

    template(v-if="analytic && value.other_text_answers")
      v-card-title Ответы пользователей

      v-sheet(
        v-for="(answer, idx) in value.other_text_answers"
        :key="idx"
        color="grey lighten-4"
      ).pa-5.mb-5.sdo-radius {{ answer }}

</template>

<script>
export default {
  name: 'TypeText',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    analytic: {
      type: Boolean, default: false,
    },
  },
};
</script>
